import PageLayout from "../../components/feature/PageLayout";
import InfoPageHero from "../../components/feature/InfoPageHero";
import InfoPageFinalCTA from "../../components/feature/InfoPageFinalCTA";
import InfoPageFooter from "../../components/feature/InfoPageFooter";
import TestimonialsSection from "./components/TestimonialsSection";
import ReviewsList from "./components/ReviewsList";
import { useReviewsData } from "../../lib/useMockData";

export default function Reviews() {
  const { heroData } = useReviewsData();
  return (
    <PageLayout>
      <InfoPageHero
        label="VOICE"
        title={heroData.title}
        subtitle={heroData.subtitle}
        image={heroData.image}
        alt="お客様の声"
      />
      <TestimonialsSection />
      <ReviewsList />
      <InfoPageFinalCTA
        title="あなたも、特別な体験を始めませんか？"
        subtitle="初めての方も安心。専任スタッフが丁寧にサポートいたします"
        ctas={[
          { label: "予約について問い合わせる", href: "/contact", type: "primary" },
          { label: "横浜ヘリクルージングを見る", href: "/yokohama", type: "secondary" },
        ]}
      />
      <InfoPageFooter />
    </PageLayout>
  );
}
